module.exports = __webpack_public_path__ + "img/logo_gejuyun.7971b80b.png";